import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetActivitiesChangesQuery,
  GetActivitiesChangesQueryVariables,
} from './settings-publish.graphql.generated';
import { GET_ACTIVITIES_CHANGES } from './settings-publish.graphql';
import { ActivitiesContentType } from 'global/constants';

const useGetActivitiesChanges = ({
  contentId,
  contentType,
}: {
  contentId: number;
  contentType: ActivitiesContentType;
}) => {
  const { data } = useLoggingQuery<
    GetActivitiesChangesQuery,
    GetActivitiesChangesQueryVariables
  >(GET_ACTIVITIES_CHANGES, {
    fetchPolicy: 'cache-only',
    variables: {
      input: {
        contentId,
        contentType,
      },
    },
  });

  return { data };
};

export default useGetActivitiesChanges;
